import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';

interface LayerProps {
  depth: number;
}

export const fullscreen = css`
  width: 100%;
  height: 100%;
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  
  100%{
    opacity: 1;
  }
`;

export const DarkLayer = styled.div<LayerProps>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(51, 51, 51, 0.6);
  z-index: ${({ depth }) => depth * 10000};
  animation: ${fadeIn} 500ms;
`;

export const Container = styled.div<LayerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: ${({ depth }) => depth * 10001};
  animation: ${fadeIn} 500ms;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* max-height: 640px; */
  position: relative;
  background: ${({ theme }) => theme.colors.neutral[0]};
  border-radius: 8px;
  box-shadow: 0px 10px 30px 0px rgba(51, 51, 51, 0.2);

  @media (max-height: 900px) {
    max-height: calc(100vh - 32px);
  }
`;

export const Header = styled.div<{ hasBorderBottom?: boolean; mode: string }>`
  display: flex;
  width: 100%;
  height: 64px;
  min-height: 64px;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px 12px 24px;
  justify-content: space-between;
  gap: 10px;
  ${({ hasBorderBottom, mode, theme }) =>
    hasBorderBottom
      ? mode === 'dark'
        ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.12)'
        : `border-bottom: 1px solid ${theme.colors.neutral[200]}`
      : ''};
`;

export const SelectedMemberCount = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

export const Content = styled.div`
  max-height: calc(100vh - 176px); // 상하 여백(40) + 헤더(64) + 푸터(72) = 176
  color: ${({ theme }) => theme.colors.neutral[400]};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const Footer = styled.div<{ mode: string }>`
  display: flex;
  width: 100%;
  height: 72px;
  min-height: 72px;
  padding: 16px 24px;
  border-top: 1px solid
    ${({ theme, mode }) => (mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : theme.colors.neutral[200])};
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
`;

export const SubBtn = styled.div`
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const ButtonGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 12px;
`;

export const FooterFlexBox = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  justify-content: space-between;
`;

export const FooterLeft = styled.div`
  display: flex;
  align-items: center;
`;
